import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { type ComponentProps } from "react";
import { nl } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import css from "./DateTimePicker.module.scss";
import { type PickersLocaleText } from "@mui/x-date-pickers/locales";
import { useTranslation } from "react-i18next";

export type DateTimePickerProps = ComponentProps<typeof MuiDateTimePicker>;

export const DateTimePicker = ({
    views = ["year", "month", "day", "hours"],
    disablePast = false,
    onChange,
    defaultValue = new Date(),
}: DateTimePickerProps) => {
    const { t } = useTranslation("common");
    const localeText: Partial<PickersLocaleText> = {
        fieldHoursPlaceholder() {
            return "00:00";
        },
        cancelButtonLabel: t("cancel"),
        okButtonLabel: t("general.oke"),
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={nl}
            localeText={localeText}
        >
            <MuiDateTimePicker
                className={css.MultiDatePicker}
                views={views}
                defaultValue={defaultValue}
                onChange={onChange}
                disablePast={disablePast}
                closeOnSelect={false}
                format="dd-MM-yyyy HH:00"
            />
        </LocalizationProvider>
    );
};

export default DateTimePicker;
